import api from "lib/axios";
import { authStorage } from "services/authStorage";

type ApiSuccess<T> = { status: "success" | string; result: { data: T }; message: string };

export type AdminAuthUser = {
  id: number;
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  image?: string | null;
  image_url?: string | null;
  is_active?: boolean;
  guard?: string | null;
  token?: string;
  abilities?: string[];
  roles?: string[];
  permissions?: string[];
};

type AdminLoginCredentials = { email: string; password: string };

export const adminAuthService = {
  async login(credentials: AdminLoginCredentials): Promise<AdminAuthUser> {
    const response = await api.post<ApiSuccess<AdminAuthUser>>("/mcp/v1/login", credentials);
    const user = response.data.result?.data;
    if (user?.token) authStorage.setToken("admin", user.token);
    return user;
  },

  async getProfile() {
    const response = await api.get<ApiSuccess<AdminAuthUser>>("/mcp/v1/profile/edit", {
      meta: { toastSuccess: false },
    });
    return response.data.result?.data;
  },

  async updateProfile(data: Record<string, unknown>) {
    const response = await api.put<ApiSuccess<AdminAuthUser>>("/mcp/v1/profile/update", data);
    return response.data.result?.data;
  },

  async updatePassword(data: { current_password: string; password: string; password_confirmation: string }) {
    const response = await api.put("/mcp/v1/profile/password/update", data);
    return response.data;
  },

  logout() {
    authStorage.clearToken("admin");
    window.location.href = authStorage.loginPath("admin");
  },
};

